import React from "react";
import UserLayout from "./UserMainLayout.jsx";
import BlankLayout from "./UserBlankLayout.jsx";
import RegisterLayout from "./UserRegisterLayout.jsx";
import { Route, Switch, Redirect } from "react-router-dom";

import config from "config.js";

const UserRoute = (props) => {
  const EnhacedUserLayout = (passThroughProps) => {
    return (
      <UserLayout
        {...passThroughProps}
        routes={props.routes}
        userNames={props.userNames}
        associatedAccounts={props.associatedAccounts}
        warningActive={props.warningActive}
        globalNotification={props.globalNotification}
      />
    );
  };

  return (
    <Switch>
      <Route
        path={config.MYACCOUNT.APP_PATH + "/register"}
        component={RegisterLayout}
      />
      <Route
        path={config.MYACCOUNT.APP_PATH + "/user"}
        component={EnhacedUserLayout}
      />
      <Route
        path={config.MYACCOUNT.APP_PATH + "/will"}
        component={BlankLayout}
      />
      <Redirect
        from={config.MYACCOUNT.APP_PATH + "/"}
        to={props.defaultRedirect}
      />
    </Switch>
  );
};

export default UserRoute;
